import React from "react";
import { GustoIntegrationSection } from "@src/pages/settings/Integrations/GustoIntegrationSection";
import styled from "styled-components/macro";

const StyledDiv = styled.div`
  margin: 3rem;

  .hris-integrations {
    margin: 3rem 0;
  }
`;

export function HeadcountLogin() {
  return (
    <StyledDiv>
      <h2>Log in to a HRIS/Payroll system</h2>
      <p>
        Track current headcount spend and plan for future headcount spend by
        connecting a Payroll system to Sudozi.
      </p>
      <div className="hris-integrations">
        <GustoIntegrationSection hrIntegrations={[]} />
      </div>
    </StyledDiv>
  );
}
